export const FETCH_PROJECT_START = 'FETCH_PROJECT_START';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_ERROR = 'FETCH_PROJECTS_ERROR';
export const PROJECT_CREATION_START = 'PROJECT_CREATION_START';
export const PROJECT_CREATION_END = 'PROJECT_CREATION_END';
export const UPDATE_PROJECT_DEFINITION = 'UPDATE_PROJECT_DEFINITION';
export const SUBMIT_PROJECT_DEFINITION = 'SUBMIT_PROJECT_DEFINITION';
